import type {ReactNode} from 'react'
import {InfoGlyph} from '@/components/ui/icons'
import {Popover, PopoverContent, PopoverTrigger} from '@/components/ui/popover'
import {cn} from '@/lib/utils'

/** WCAG 2.2 SC 2.5.8 pide 24×24 px: un pseudo-elemento recibe el toque sin agrandar la caja que lo hospeda. */
export const AREA_TACTIL =
  "relative align-middle before:absolute before:top-1/2 before:left-1/2 before:h-6 before:w-6 before:-translate-x-1/2 before:-translate-y-1/2 before:content-['']"

/** Popover y no Tooltip: Radix Tooltip no abre al tap, así que dejaría a un teléfono sin la información. */
export function InfoTip({
  label,
  tip,
  children,
  testId,
  side = 'top',
  className,
  contenedor,
}: {
  /** Dice de qué es la ayuda, nunca «Ver ayuda»: el disparador no tiene texto propio (T11). */
  label: string
  tip: ReactNode
  children?: ReactNode
  testId?: string
  side?: 'top' | 'right' | 'bottom' | 'left'
  className?: string
  /** Dentro de un diálogo modal, el nodo del `DialogContent` (ver `popover.tsx`). */
  contenedor?: HTMLElement | null
}) {
  return (
    <Popover>
      <PopoverTrigger
        type="button"
        aria-label={label}
        data-testid={testId}
        className={cn(
          'inline-flex shrink-0 items-center justify-center gap-1 rounded-full text-muted-foreground outline-none hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring/50',
          AREA_TACTIL,
          className
        )}>
        {children ?? <InfoGlyph />}
      </PopoverTrigger>
      <PopoverContent
        side={side}
        container={contenedor}
        aria-label={label}
        className="max-w-[18rem] p-2.5 text-xs text-popover-foreground">
        {tip}
      </PopoverContent>
    </Popover>
  )
}
